import React from 'react';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import { ReactComponent as Logo } from '../../assets/images/logo.svg';
import { ReactComponent as LogoLarge } from '../../assets/images/logo-large.svg';

interface HeaderLogoProps {
  isLarge?: boolean;
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({ isLarge = false }) => {
  const { t } = useTranslation();

  return (
    <CoreLink href="/" className="SiteLogo" aria-label={t('components.site_logo.aria-label')}>
      {isLarge ? (
        <LogoLarge />
      ) : (
        <Logo />
      )}
    </CoreLink>
  );
};

export default HeaderLogo;
